<template>
  <div
    class="relative flex w-full max-w-[500px] flex-col rounded-xl bg-white p-[22px] [box-shadow:0_20px_60px_0_rgb(0_0_0_/_50%),_0_2px_10px_0_rgb(0_0_0_/_10%)] tablet-h:max-w-[600px] tablet-h:px-[30px] tablet-h:py-6"
  >
    <slot />
    <div
      v-if="!hideCloseButton"
      class="group absolute right-2 top-2 flex h-[22px] w-[22px] cursor-pointer items-center justify-center rounded-md transition hover:bg-gray-200/25"
      @click="close()"
    >
      <Icon
        :size="13"
        name="Plus"
        class="rotate-45 stroke-gray-500/50 transition group-hover:stroke-gray-500"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@dacr/ui'
import { useDialog } from './useDialog'

defineProps<{
  hideCloseButton?: boolean
}>()

const { close } = useDialog()
</script>
